import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { CallSplitOutlined, SettingsEthernetOutlined } from "@mui/icons-material";

import { i18n } from "../../translate/i18n";
import AsteriskControlSettings from "../AsteriskControlSettings";
import CallRecordsSettings from "../CallRecordsSettings";

const PhoneSystemSettings = () => {
  const [tab, setTab] = useState("connection");

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, width: "100%" }}>
      <Tabs
        value={tab}
        onChange={(e, value) => setTab(value)}
        indicatorColor="primary"
        textColor="primary"
        sx={{ borderBottom: 1, borderColor: "divider", minHeight: 40 }}
      >
        <Tab
          value="connection"
          icon={<SettingsEthernetOutlined fontSize="small" />}
          iconPosition="start"
          label={i18n.t("settings.phoneSystemTabs.connection")}
          sx={{ minHeight: 40, textTransform: "none" }}
        />
        <Tab
          value="callRecords"
          icon={<CallSplitOutlined fontSize="small" />}
          iconPosition="start"
          label={i18n.t("settings.phoneSystemTabs.callRecords")}
          sx={{ minHeight: 40, textTransform: "none" }}
        />
      </Tabs>

      {tab === "connection" ? <AsteriskControlSettings /> : <CallRecordsSettings />}
    </Box>
  );
};

export default PhoneSystemSettings;
